import React from 'react';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';

import { useGlobalContext } from 'contexts/global-context';
import useThrottleClick from 'hooks/useThrottleClick';
import useGameSelection from 'hooks/useGameSelection';
import GridGames, { MainItemPosition } from 'components/grid-games';
import ButtonLink from 'components/button-link';
import { TGame, Genre, Route, ABTest } from 'types';

interface IPokiGenreGames {
  games: TGame[];
  genre: Genre;
  genreOrder: number;
}

const PokiGenreGames: React.FC<IPokiGenreGames> = ({ games, genre, genreOrder }) => {
  const { t } = useTranslation();
  const { abTestId } = useGlobalContext();
  const positions = Object.values(MainItemPosition);
  const slicedGames = games.length > 0 ? games.slice(0, abTestId === ABTest.switchMainVideo ? 6 : 7) : games;
  const { selectedGame, select, pause } = useGameSelection(slicedGames, abTestId === ABTest.autoShowGetBtnOnGame);

  const onMoreLinkClick = useThrottleClick(Route.genres, genre);

  const handleGameClick = (game: TGame) => {
    select(game);

    if (abTestId === ABTest.autoShowGetBtnOnGame) {
      pause(true);
    }
  };

  return (
    <>
      <GridGames
        selectedGame={selectedGame}
        mainItemPosition={positions[genreOrder % 4]}
        games={slicedGames}
        onGameClick={handleGameClick}
      />
      <ButtonLink onClick={onMoreLinkClick}>{t(`more${upperFirst(genre)}`)}&nbsp;→</ButtonLink>
    </>
  );
};

export default PokiGenreGames;
